"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDisplace = _interopRequireDefault(require("react-displace"));

var _debounce = _interopRequireDefault(require("debounce"));

var _calculatePosition = _interopRequireDefault(require("./calculate-position"));

var _getScrollableParents = _interopRequireDefault(require("./get-scrollable-parents"));

var _createScrollListener = _interopRequireDefault(require("./create-scroll-listener"));

var _getWindow = _interopRequireDefault(require("../utils/get-window"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var popoverPositionerList = [];
/**
 * Secretly mounts a popover and its pointer, calculates their positions, then repositions and exposes them.
 *
 * @param {ReactNode} children
 * @param {Function} getAnchorElement - Function that returns the popover's anchor element.
 * @param {'top' | 'bottom' | 'left' | 'right' } [placement] - See options for calculatePosition.
 * @param { 'top' | 'bottom' | 'left' | 'right' | 'center' } [alignment] - See options for calculatePosition.
 * @param {boolean} [hasPointer] - See options for calculatePosition.
 * @param {number} [pointerBase] - See options for calculatePosition.
 * @param {number} [pointerAltitude] - See options for calculatePosition.
 * @param {string} [pointerColor] - See options for calculatePosition.
 * @param {number} [offsetFromAnchor] - See options for calculatePosition.
 * @param {boolean} [hideWhenAnchorIsOffscreen] - See options for calculatePosition.
 * @param {boolean} [allowPlacementAxisChange] - See options for calculatePosition.
 * @param {boolean} [containWithinViewport] - See options for calculatePosition.
 * @param {Function} [getContainingElement] - See options for calculatePosition.
 * @param {Function} [onElement] - A function that receives the containing element.
 * @param {number} [zIndex] - z-index for body element.
 */

var PopoverPositioner =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(PopoverPositioner, _React$PureComponent);

  function PopoverPositioner() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PopoverPositioner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PopoverPositioner)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollableParentElement", function () {
      return _this.scrollableParents[0];
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setPosition", function () {
      var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
          props = _assertThisInitialize.props;

      var positionData = _this.props.calculatePosition({
        getScrollableParentElement: _this.getScrollableParentElement,
        getPopoverElement: _this.getPopoverElement,
        getAnchorElement: props.getAnchorElement,
        placement: props.placement,
        alignment: props.alignment,
        hasPointer: props.hasPointer,
        offsetFromAnchor: props.offsetFromAnchor,
        pointerBase: props.pointerBase,
        pointerAltitude: props.pointerAltitude,
        pointerColor: props.pointerColor,
        hideWhenAnchorIsOffscreen: props.hideWhenAnchorIsOffscreen,
        allowPlacementAxisChange: props.allowPlacementAxisChange,
        containWithinViewport: props.containWithinViewport,
        getContainingElement: props.getContainingElement
      });

      var bodyElement = _this.bodyElement;

      if (bodyElement) {
        bodyElement.style.setProperty('visibility', 'visible');

        for (var key in positionData.bodyPositioningStyle) {
          bodyElement.style.setProperty(key, positionData.bodyPositioningStyle[key]);
        }
      }

      var pointerElement = _this.pointerElement;

      if (pointerElement) {
        pointerElement.style.setProperty('visibility', 'visible');

        for (var _key2 in positionData.pointerPositioningStyle) {
          pointerElement.style.setProperty(_key2, positionData.pointerPositioningStyle[_key2]);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setBodyElement", function (element) {
      _this.bodyElement = element;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setContainerElement", function (element) {
      _this.containerElement = element;
      if (_this.props.onElement) _this.props.onElement(element);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPopoverElement", function () {
      return _this.bodyElement;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setPointerElement", function (element) {
      _this.pointerElement = element;
    });

    return _this;
  }

  _createClass(PopoverPositioner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      popoverPositionerList.push(this.setPosition);
      this.scrollableParents = this.props.getScrollableParents(this.props.getAnchorElement());
      this.handleResize = (0, _debounce.default)(this.setPosition, 200);
      this.props.getWindow().addEventListener('resize', this.handleResize);
      this.scrollListeners = this.scrollableParents.map(function (scrollableParent) {
        var scrollListener = _this2.props.createScrollListener(scrollableParent, _this2.setPosition);

        scrollListener.start();
        return scrollListener;
      }, this);
      this.setPosition();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setPosition();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.getWindow().removeEventListener('resize', this.handleResize);
      this.scrollListeners.forEach(function (scrollListener) {
        scrollListener.stop();
      });
      popoverPositionerList.splice(popoverPositionerList.indexOf(this.setPosition), 1);
    }
  }, {
    key: "render",
    value: function render() {
      var basicStyle = {
        position: 'absolute',
        zIndex: this.props.zIndex,
        top: 0,
        left: 0,
        visibility: 'hidden'
      };
      return _react.default.createElement("div", {
        ref: this.setContainerElement
      }, _react.default.createElement("div", {
        "data-test": "popover-body",
        ref: this.setBodyElement,
        style: basicStyle
      }, this.props.children), _react.default.createElement("div", {
        "data-test": "popover-pointer",
        ref: this.setPointerElement,
        style: basicStyle
      }));
    }
  }]);

  return PopoverPositioner;
}(_react.default.PureComponent);

_defineProperty(PopoverPositioner, "propTypes", {
  children: _propTypes.default.node.isRequired,
  getAnchorElement: _propTypes.default.func.isRequired,
  placement: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']),
  alignment: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right', 'center']),
  pointerBase: _propTypes.default.number,
  hasPointer: _propTypes.default.bool,
  pointerAltitude: _propTypes.default.number,
  pointerColor: _propTypes.default.string,
  offsetFromAnchor: _propTypes.default.number,
  hideWhenAnchorIsOffscreen: _propTypes.default.bool,
  allowPlacementAxisChange: _propTypes.default.bool,
  containWithinViewport: _propTypes.default.bool,
  getContainingElement: _propTypes.default.func,
  onElement: _propTypes.default.func,
  zIndex: _propTypes.default.number,
  // For mockery
  calculatePosition: _propTypes.default.func,
  getScrollableParents: _propTypes.default.func,
  createScrollListener: _propTypes.default.func,
  getWindow: _propTypes.default.func
});

_defineProperty(PopoverPositioner, "defaultProps", {
  calculatePosition: _calculatePosition.default,
  getScrollableParents: _getScrollableParents.default,
  createScrollListener: _createScrollListener.default,
  getWindow: _getWindow.default
});

var displaced = (0, _reactDisplace.default)(PopoverPositioner);

displaced.recalculatePositions = function () {
  popoverPositionerList.forEach(function (recalcFn) {
    recalcFn();
  });
};

var _default = displaced;
exports.default = _default;